'use client';

import { createContext } from 'react';

export interface PageRendererContextProps {
   isConsumer: boolean;
}

export const PageRendererContext = createContext<PageRendererContextProps | null>({ isConsumer: true });
